import React from 'react';
import {observer} from 'mobx-react';
import {Box} from '../../../components/box';
import moment from 'moment';
import bundleStore, {overlaps} from '../../../store/bundleStore';
import shopStore from '../../../store/shopStore';
export const itemLabel = item => `${moment(item.sdStart).format('YYYY-MM-DD HH:mm')} – ${moment(item.sdEnd).format('HH:mm')} · ${item.stName || item.stNo}`;
const entryPin = pin => <div className="bundle-done-pin">
    <p className="bundle-done-caption">입장 PIN</p>
    <strong className="bundle-done-pin-value">{pin}</strong>
</div>;
export default observer(function BundleList({complete = false, readOnly = false}) {
    if (!complete && !shopStore.bundleEnabled) return null;
    const items = complete ? bundleStore.result?.orders : bundleStore.items;
    if (!items?.length) return null;
    if (complete) {
        const sharedPin = items[0].pin != null && items.every(item => String(item.pin) === String(items[0].pin)) ? items[0].pin : null;
        return <>
            <section className="bundle-done-card bundle-done-list" aria-label="예약 완료 목록">
                <h2>예약 {items.length}건 완료</h2>
                <ul>{items.map((item, i) => {
                    const start = moment(item.sdStart);
                    const headcount = item.headcount ?? bundleStore.items[i]?.headcount;
                    return <li key={item.odCode || `${item.stNo}-${item.sdStart}`}>
                        <div className="bundle-done-row">
                            <div className="bundle-done-schedule">
                                <p className="bundle-done-date">{start.format('M월 D일')} ({['일', '월', '화', '수', '목', '금', '토'][start.day()]})</p>
                                <p className="bundle-done-time">{start.format('HH:mm')} – {moment(item.sdEnd).format('HH:mm')}</p>
                            </div>
                            <div className="bundle-done-room">
                                <span className="bundle-done-room-chip">{item.stName || item.stNo}</span>
                                <p>{headcount != null && <>{headcount}명 · </>}<span className="bundle-done-amount">{item.price?.toLocaleString('ko-KR')}원</span></p>
                            </div>
                        </div>
                        {!sharedPin && item.pin && entryPin(item.pin)}
                    </li>;
                })}</ul>
            </section>
            <section className="bundle-done-card bundle-done-entry" aria-label="입장 정보">
                <h2>입장 정보</h2>
                {sharedPin ? entryPin(sharedPin) : null}
                <p className="bundle-done-caption">예약 내용을 문자로 보내드렸습니다</p>
            </section>
        </>;
    }
    return <Box className='sect bundle-list' id={!complete && !readOnly ? 'bundle-cart' : undefined} aria-label={complete ? '예약 완료 목록' : '담긴 예약 목록'}>
        <h4>{complete ? `예약 ${items.length}건 완료` : `담긴 예약 ${items.length}건`}{!complete && bundleStore.total != null && <span className='bundle-total'>합계 {bundleStore.total.toLocaleString()}원</span>}</h4>
        <ul>{items.map((item, i) => <li key={item.odCode || `${item.stNo}-${item.sdStart}`}>
            <p>{itemLabel(item)} · {item.headcount ?? bundleStore.items[i]?.headcount}명 · {item.price?.toLocaleString()}원</p>
            {!complete && <button type="button" disabled={readOnly || bundleStore.busy || !!bundleStore.hold || !!bundleStore.payment} onClick={() => bundleStore.remove(i)}>삭제</button>}
            {!complete && bundleStore.conflicts.some(other => overlaps(item, other) || (other.stNo === item.stNo && !other.sdStart)) && <p role="alert" className='bundle-conflict'>예약 충돌</p>}
        </li>)}</ul>
        {complete && <><p>PIN {items[0]?.pin}</p><p>문자 1통 발송</p></>}
    </Box>;
});
